// extracted by mini-css-extract-plugin
module.exports =  {"preloader":"_35875ce240--preloader--futYv","spin":"_35875ce240--spin--boFQ3"};